import React, { useState } from 'react';
import { Button, Form, Input, message } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useFirebase } from '../FirebaseContext';
import AuthLayout from '../components/AuthLayout';
import logo from '../assets/spario.png';
import '../components/AuthLayout.css';

const Login = () => {
  const [loading, setLoading] = useState(false);
  const [systemLoading, setSystemLoading] = useState(false);
  const navigate = useNavigate();

  const { currentFirebase } = useFirebase();
  const auth = currentFirebase?.auth;

  const onFinish = async ({ email, password }) => {
    if (!auth) return message.error('Błąd konfiguracji Firebase');

    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
      // Show system loading screen
      setSystemLoading(true);
      setTimeout(() => {
        navigate('/');
      }, 1500);
    } catch (err) {
      let msg = 'Błąd logowania';
      if (err.code === 'auth/invalid-credential' || err.code === 'auth/wrong-password') msg = 'Nieprawidłowe dane logowania';
      else if (err.code === 'auth/user-not-found') msg = 'Nie znaleziono użytkownika';
      else if (err.code === 'auth/too-many-requests') msg = 'Zbyt wiele prób. Spróbuj później';
      message.error(msg);
      setLoading(false);
    }
  };

  if (systemLoading) {
    return (
      <div className="system-loading">
        <div className="system-loading-logo"><img src={logo} alt="Spario" /></div>
        <div className="system-loading-spinner" />
        <div className="system-loading-text">Ładowanie systemu...</div>
      </div>
    );
  }

  return (
    <AuthLayout>
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <h2 style={{ fontSize: 22, fontWeight: 600, color: '#1f2937', margin: 0 }}>Zaloguj się</h2>
      </div>

      <Form name="login" layout="vertical" autoComplete="off" onFinish={onFinish}>
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { required: true, message: 'Wprowadź email' },
            { type: 'email', message: 'Nieprawidłowy email' },
          ]}
        >
          <Input autoComplete="username" placeholder="email@firma.pl" />
        </Form.Item>

        <Form.Item
          label="Hasło"
          name="password"
          rules={[{ required: true, message: 'Wprowadź hasło' }]}
        >
          <Input.Password autoComplete="current-password" placeholder="Hasło" />
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <Button type="primary" htmlType="submit" loading={loading} block>
            Zaloguj się
          </Button>
        </Form.Item>
      </Form>
    </AuthLayout>
  );
};

export default Login;
